export default "__VITE_ASSET__CjEV1Gq7__"